module.exports = __webpack_public_path__ + "img/isps.7d6db4d8.png";